import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connectCalendarWithCode } from '../../api/calendar';

const CalendarGooglePage = () => {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    useEffect(() => {
        if (!code) {
            navigate('/', { replace: true });
            return;
        }

        const returnTo = sessionStorage.getItem('calendarConnectReturnTo') ?? '/';
        sessionStorage.removeItem('calendarConnectReturnTo');

        connectCalendarWithCode(code)
            .then(() => {
                navigate(returnTo, { replace: true });
            })
            .catch(() => {
                alert('캘린더 연동 중 오류가 발생했습니다.');
                navigate(returnTo, { replace: true });
            });
    }, [code, navigate]);

    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#000000',
                color: '#888888',
                fontFamily: 'Pretendard',
                fontSize: '15px',
            }}
        >
            캘린더 연동 중...
        </div>
    );
};

export default CalendarGooglePage;
